import apiPaths from '../api-paths';

export default {
  store({ declaration }) {
    return axios.post(`${ apiPaths.API }/zus/declarations`, declaration);
  },
  update({ declaration }) {
    return axios.put(`${ apiPaths.API }/zus/declarations/` + declaration.id, { zusdeclaration: declaration });
  },
  addToPackage({ zusPackageId, declaration }) {
    return axios.post(`${ apiPaths.API }/zus/declarations/add-to-package/${ zusPackageId }`, declaration);
  },
  printPdf({declarationId}, params = {}) {
    return axios
      .get(
        `${ apiPaths.API }/zus/declarations/${declarationId}/print`,
        {
          params,
        },
      );
  },
};
